/** FIXME: Had to repeat the template here. Should just work off of BaseChart ideally */
<template lang="html">
    <div class="panel panel-default chart-container">

      <div class="panel-heading text-center">
        <!-- <button class="btn btn-default btn-xs pull-left refresh-button" style="display: inline;"
                @click="refresh">
          <i class="fas fa-sync-alt"></i>
        </button> -->
        <h5 class="chart-title" style="display: inline-block">{{ title }}</h5>
        <button class="btn btn-warning btn-sm pull-right export-button" style="display: inline;"
              data-toggle="tooltip"
              data-placement="top"
              title="Export this chart's data as CSV"
              v-if="this.$store.getters.filteredStats.length > 0"
              @click.stop="exportCSV(reportName)">
          <i class="fas fa-download"></i>
        </button>
      </div>

      <div class="panel-body">

        <!-- Select GroupCourse -->
        <div class="select">
            <select class="form-control" v-model="chartCourse" v-if="availableGroupCourses.length" @change="chartCourseUpdated">
              <option v-for="course in availableGroupCourses" :value="course" :key="course.GroupCourseMasterId">{{ course.CourseTitle }}</option>
            </select>

            <p class="text-center text-danger" v-else>
              <i class="fas fa-exclamation-triangle"></i>
              <small>
                <strong>Please select at least 1 Course from the dropdown above.</strong>
              </small>
            </p>
        </div>
        <!-- Select GroupCourse -->

        <!-- Chart -->
        <canvas width="420" height="200" ref="canvas"></canvas>
        <!-- Chart -->
      </div>

      <!-- <div class="panel-footer">
        <div class="text-muted text-center">
          <i class="fas fa-info-circle"></i>
          <small>{{ info }}</small>
        </div>
      </div> -->

    </div>
</template>


<script>
import BaseChart from '@/components/dashboard/charts/BaseChart'

export default BaseChart.extend({

  name: 'stacked-bar-chart',

  data () {
    return {
      type: 'bar',
      chartCourse: {},
      chartOptions: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },

  computed: {
    values () {
      return this.$store.getters.stackedBarGraphData(this.chartCourse)
    },

    labels () {
      return Object.values(this.$store.getters.stackedBarGraphLabels)
    },

    availableGroupCourses () {
      return (this.$store.state.selectedGroupCourses.length)
        ? this.$store.state.selectedGroupCourses
        : []
    },

    dataSet () {
      let dataSet = []
      let cohortIds = Object.keys(this.values)
      let cohortsLen = cohortIds.len
      let borderColors = this.getColors('solid', cohortsLen)
      let bgColors = this.getColors('transparent', cohortsLen)

      cohortIds.forEach((cohortId, index) => {
        dataSet.push({
          label: this.$store.getters.cohortNameById(cohortId),
          // FIXME: ORDER IS NOT GUARANTEED
          data: Object.values(this.values[cohortId]),
          backgroundColor: bgColors[index],
          borderColor: borderColors[index],
          borderWidth: 1
        })
      })

      return dataSet
    },

    chartData () {
      return {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: this.dataSet
        },
        options: this.chartOptions
      }
    }
  },

  beforeDestroy () {
    /** Remove any event listeners */
    this.eventHub.$off('progBucketsUpdated')
    this.eventHub.$off('groupCourseCohortFilterUpdated')
    this.eventHub.$off('gccFilterUpdated')
  },

  mounted () {
    /** Listen for when Progress Buckets are updated */
    this.eventHub.$on(['progBucketsUpdated', 'groupCourseCohortFilterUpdated', 'gccFilterUpdated'], this.refresh)

    this.errorCheck()

    this.$set(this.$data, 'chartCourse', this.availableGroupCourses[0])

    this.render(this.chartData)
  },

  watch: {
    availableGroupCourses: function (value) {
      this.chartCourse = this.availableGroupCourses[0]
    }
  },

  methods: {
    chartCourseUpdated () {
      this.refresh()
    },

    errorCheck () {
      if (this.$store.state.selectedGroupCourses.length === 0) {
        this.errorBag = {
          status: 'danger',
          message: 'Please select at least 1 Group and 1 GroupCourse at the top.'
        }
      } else {
        this.errorBag = {
          status: '',
          message: ''
        }
      }
    },

    exportCSV (reportName) {
      this.eventHub.$emit('exportCSV', reportName)
    }
  }
})
</script>

<style lang="scss">
.export-button {
  display: inline;
  background-color: rgba(255, 104, 0, 0.90) !important;
  border: 1px solid rgba(255, 104, 0, 1.00) !important;
}


.export-button {
  display: none !important;
}

.chart-container canvas {
  max-width: 420px;
  max-height: 200px;
}

.chart-container .panel-footer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/charts/StackedBarChart.vue